import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output, booleanAttribute, input } from '@angular/core';

import { DsDivider } from '@frontend/ui/divider';
import { DsListItem } from '@frontend/ui/list-item';
import { DsNotificationBubble } from '@frontend/ui/notification-bubble';
import { PlainLinkComponent } from '@frontend/vanilla/core';
import { SpeculativeLinkDirective } from '@frontend/vanilla/features/speculative-link';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    selector: 'ms-list-item',
    templateUrl: './list-item.component.html',
    styleUrls: ['./list-item.component.scss'],
    imports: [IconCustomComponent, DsListItem, DsDivider, DsNotificationBubble, NgTemplateOutlet, PlainLinkComponent, SpeculativeLinkDirective],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemComponent {
    @HostBinding('class') className = 'list-item-ds';

    @Input() title?: string;
    @Input() subTitle?: string;
    @Input() count?: number;
    @Input() icon?: string;
    @Input() iconSize?: string;
    @Input() href?: string;
    arrowIconSize = input<string>('16');
    boldTitle = input(false, { transform: booleanAttribute });
    arrow = input(true, { transform: booleanAttribute });
    isShowBorder = input(true, { transform: booleanAttribute });
    badge = input(false, { transform: booleanAttribute });
    isActive = input(false, { transform: booleanAttribute });
    showStartSlot = input(true, { transform: booleanAttribute });
    @Output() itemClicked = new EventEmitter<void>();

    clicked() {
        this.itemClicked.emit();
    }
}
